function FundacionHeader() {
    return (
        <section className="mb-10 md:mb-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-white border-l-4 border-red-500 pl-4">
                Nuestra Historia
            </h1>
        </section>
    );
}

export default FundacionHeader;
